import { apiClient } from "./apiClient";

export interface UploadResponse {
  fileUrl: string;
  signedUrl: string;
  objectPath: string;
  contentType: string;
}

export const uploadsService = {
  upload(file: File, contentType: string): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("contentType", contentType);

    return apiClient
      .post<UploadResponse>("/uploads", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => response.data);
  },
};
